var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBalloon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#60BDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9C20.9062 9 24.4688 11.9375 24.4688 15.5C24.4688 19.0938 20.9062 22 16.5 22C15.2812 22 14.1562 21.7812 13.125 21.4062C12.3438 22.0312 10.8125 23 8.75 23C8.625 23 8.53125 22.9688 8.5 22.875C8.46875 22.7812 8.46875 22.6562 8.5625 22.5938C8.5625 22.5625 9.875 21.1875 10.25 19.5938C9.15625 18.4688 8.5 17.0625 8.5 15.5C8.5 11.9375 12.0625 9 16.5 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBalloon);
export default __webpack_public_path__ + "static/media/circle-balloon.3a7b20639424724fbc07606e7856efc7.svg";
export { ForwardRef as ReactComponent };